
export const TASK_FETCH   = 'TASK_FETCH';
export const TASK_UPDATE  = 'TASK_UPDATE';
export const TASK_CONFIRM = 'TASK_CONFIRM';
export const TASK_REMOVE  = 'TASK_REMOVE';
export const TASK_CANCEL  = 'TASK_CANCEL';
export const TASK_ERROR   = 'TASK_ERROR';